import type { HTMLAttributes, ReactNode } from "react";
import { cx } from "./cx";

interface CardProps extends HTMLAttributes<HTMLElement> {
  /** Raised cards carry the big hard shadow; plain ones only the border. */
  raised?: boolean;
  as?: "section" | "div" | "article";
}

export function Card({ raised, as: Tag = "section", className, ...rest }: CardProps) {
  return <Tag className={cx("overflow-hidden rounded-xl border-2 border-ink bg-card", raised && "shadow-hard-lg", className)} {...rest} />;
}

/** Heading row inside a card: title on the left, actions on the right. */
export function CardHeader({ title, actions, caption }: { title: ReactNode; actions?: ReactNode; caption?: ReactNode }) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-b-2 border-ink px-5 py-3.5">
      <div className="flex flex-col gap-0.5">
        <h2 className="text-lg font-bold">{title}</h2>
        {caption && <span className="font-mono text-xs text-muted">{caption}</span>}
      </div>
      {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
    </div>
  );
}
